export function getMascotImageSrc(imageName: string): string {
  if (imageName) {
    return `/static/images/${imageName}`;
  }
  return '';
}
